// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminCard_container__1zob4","button":"AdminCard_button__ADjAY","column":"AdminCard_column__2tmXl"};